import { pushEventToDataLayer } from '@helpers/dataLayer';
import { TRACKING_STEP_CHOISE_CHOOSE, TRACKING_STEP_CHOISE_DEFAULT } from '../constants/GaTrackingStepChoise';
import assembleCheckoutData from './GaAssembleCheckoutData';

export const isCheckoutStepPushed = (step) => {
    const findStep = item => item.event_info?.label === step || item.event_info?.action === step;
    return window.dataLayer.some(findStep);
};

export const trackCheckoutStep = (currentStep, choice = TRACKING_STEP_CHOISE_CHOOSE, confirmStep = 5) => {
    if (currentStep >= 3) {
        const steps = [1, 2, 3, 4, 5];
        steps.splice(currentStep - 1, steps.length - (currentStep - 1));

        // Makes sure to push all previous steps to the dataLayer
        steps.forEach((step) => {
            if (!isCheckoutStepPushed(`step ${step}`)) {
                trackCheckoutStep(step, TRACKING_STEP_CHOISE_DEFAULT);
            }
        });
    }

    const data = assembleCheckoutData(currentStep, choice, confirmStep);
    pushEventToDataLayer(data.eventName, data.eventInfo, data.eventData);
};
